import { render } from "./customer-check.vue?vue&type=template&id=2070b0d2"
import script from "./customer-check.vue?vue&type=script&lang=js"
export * from "./customer-check.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__